import { render, staticRenderFns } from "./askQuestionsDialog.vue?vue&type=template&id=8304b138&scoped=true"
import script from "./askQuestionsDialog.vue?vue&type=script&lang=js"
export * from "./askQuestionsDialog.vue?vue&type=script&lang=js"
import style0 from "./askQuestionsDialog.vue?vue&type=style&index=0&id=8304b138&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8304b138",
  null
  
)

export default component.exports